module.exports = __webpack_public_path__ + "img/会泽兴仁医院.98e8279e.png";